module.exports = __webpack_public_path__ + "static/img/radio_default.65cc49be.png";